export default __webpack_public_path__ + "static/IOT_devices-4a2effd8bf6972579bad725252c94730.png";